import { Box, Skeleton, TableCell, TableRow } from '@mui/material';

import {
    CATALOG_PRODUCT_THUMB_PX,
    catalogProductColumnWidths,
    catalogProductDataCellSx,
    catalogProductRowChromeSx,
} from 'shared/ui/CatalogProductTable';

export const OrderAddItemsListsTableRowSkeleton = () => (
    <TableRow
        data-testclass="order-add-items-list-item-row-skeleton"
        sx={{ ...catalogProductRowChromeSx, cursor: 'default' }}
    >
        <TableCell
            sx={{
                ...catalogProductDataCellSx,
                padding: '15px 16px',
                width: catalogProductColumnWidths.item,
                maxWidth: catalogProductColumnWidths.item,
                boxSizing: 'border-box',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    minWidth: 0,
                }}
            >
                <Skeleton
                    variant="rectangular"
                    width={CATALOG_PRODUCT_THUMB_PX}
                    height={CATALOG_PRODUCT_THUMB_PX}
                    sx={{ borderRadius: '4px', flexShrink: 0 }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '4px',
                        minWidth: 0,
                        flex: 1,
                    }}
                >
                    <Skeleton
                        variant="text"
                        height={24}
                        sx={{ width: 'min(280px, 100%)', maxWidth: '100%' }}
                    />
                    <Skeleton
                        variant="text"
                        height={16}
                        sx={{ width: 'min(120px, 60%)', maxWidth: '100%' }}
                    />
                </Box>
            </Box>
        </TableCell>
        <TableCell
            align="left"
            sx={{
                ...catalogProductDataCellSx,
                width: catalogProductColumnWidths.category,
                boxSizing: 'border-box',
            }}
        >
            <Skeleton variant="rounded" width={100} height={20} />
        </TableCell>
        <TableCell
            align="center"
            sx={{
                ...catalogProductDataCellSx,
                width: catalogProductColumnWidths.uom,
                boxSizing: 'border-box',
            }}
        >
            <Skeleton
                variant="rounded"
                width={36}
                height={20}
                sx={{ margin: '0 auto' }}
            />
        </TableCell>
        <TableCell
            align="center"
            sx={{
                ...catalogProductDataCellSx,
                width: catalogProductColumnWidths.defaultQty,
                boxSizing: 'border-box',
            }}
        >
            <Skeleton
                variant="rounded"
                width={32}
                height={22}
                sx={{ margin: '0 auto' }}
            />
        </TableCell>
        <TableCell
            align="right"
            sx={{
                ...catalogProductDataCellSx,
                width: catalogProductColumnWidths.orderAdd,
                boxSizing: 'content-box',
                paddingRight: '12px',
            }}
        >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Skeleton
                    variant="rounded"
                    width={67}
                    height={32}
                    sx={{ borderRadius: '4px' }}
                />
            </Box>
        </TableCell>
    </TableRow>
);
